/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'medication': {
    width: 24,
    height: 24,
    viewBox: '0 -960 960 960',
    data: '<path pid="0" d="M420-260h120v-100h100v-120H540v-100H420v100H320v120h100v100zM280-120q-33 0-56.5-23.5T200-200v-440q0-33 23.5-56.5T280-720h400q33 0 56.5 23.5T760-640v440q0 33-23.5 56.5T680-120H280zm0-80h400v-440H280v440zm-40-560v-80h480v80H240zm40 120v440-440z"/>'
  }
})
